import Grid from '@mui/material/Grid';
import { Chart } from 'react-google-charts';

import { useWeeklySalesReportChartHook } from '../hooks/chart-hook';

const WeeklySalesReportChart = () => {
  const { resultChart, optionsGrid } = useWeeklySalesReportChartHook();

  return (
    <Grid container spacing={5}>
      <Grid item size={{ xs: 12 }}>
        <Chart
          chartType='LineChart'
          width='100%'
          height='auto'
          data={resultChart}
          options={optionsGrid}
        />
      </Grid>
    </Grid>
  );
};

export default WeeklySalesReportChart;
